import { useEffect, useRef } from 'react';
import styles from './NoizeGraf.module.css';

const barCount = 450;
const barCountOne = barCount / 3;
const BAR_SPACING = 10;
const CANVAS_WIDTH = 26942; // Рекомендуется пересмотреть это значение
const CANVAS_HEIGHT = 120;

// Цвета баров
const colors = [
  ...Array(barCountOne).fill('#36ff07'), // зелёный
  ...Array(barCountOne).fill('#ffff00'), // жёлтый
  ...Array(barCountOne).fill('#ff0048'), // красный
];

// Предварительный расчёт порогов для каждого бара
const barThresholds = Array(barCount)
  .fill(0)
  .map((_, index) => {
    const barNumber = index + 1;
    return {
      threshold: (barNumber / barCount) * 100,
      prevThreshold: ((barNumber - 1) / barCount) * 100,
    };
  });

export const NoizeGraf = ({
  noiseLevel = 40,
  CANVAS_WIDTH = 26942,
  CANVAS_HEIGHT = 120,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const width = canvas.width;
    const height = canvas.height;

    // Расчёт геометрии баров (зависит только от ширины канваса)
    const barWidth = width / barCount;
    const actualBarWidth = barWidth - BAR_SPACING;
    const stepPercentage = 100 / barCount;

    // Очистка
    ctx.clearRect(0, 0, width, height);

    const targetLevel = Math.min(Math.max(noiseLevel, 0), 100);

    // Отрисовка баров
    for (let index = 0; index < barCount; index++) {
      const color = colors[index];
      const x = index * barWidth;
      const { threshold, prevThreshold } = barThresholds[index];

      // Вычисляем процент заполнения текущего бара
      let fillPercentage = 0;
      if (targetLevel >= threshold) {
        fillPercentage = 1; // полностью заполнен
      } else if (targetLevel > prevThreshold) {
        fillPercentage = (targetLevel - prevThreshold) / stepPercentage;
      }

      // Если есть что рисовать — рисуем прямоугольник
      if (fillPercentage > 0) {
        const fillWidth = actualBarWidth * fillPercentage;
        ctx.fillStyle = color;
        ctx.fillRect(x, 0, fillWidth, height);
      }
    }
  }, [noiseLevel]);

  return (
    <div className={styles.noiseGraf}>
      <canvas
        ref={canvasRef}
        width={CANVAS_WIDTH}
        height={CANVAS_HEIGHT}
        className={styles.noizeCanvas}
      />
    </div>
  );
};
